var elementsForm,contLogin;
$('.btnFormWork').click(function () {
    grecaptcha.ready(function() {
        grecaptcha.execute('6LeaIIkkAAAAALppbcYBsDBy5YsYI50NwTn5NF0o', {action: 'submit'}).then(function(token) {
            $('#formWork input[name=token]').val(token);
            $('#formWork').prepend('<input type="hidden" name="token" value="' + token + '">');
            $('#formWork').submit();
        });
    });
    //$('#formWork').submit();
});

$('#formWork').on('submit',function (e) {
    e.preventDefault();
    elementsForm = [
        "name",
        "lastname",
        "mail",
        "phone",
        "city",
        "vacancy",
    ];
    contLogin = validationForm(elementsForm,contLogin = 1);

    if(contLogin == 0)
    {
        swal({
            text: "Debes digitar todos los datos",
            icon: imageURL,
            button: "OK!",
        });
        return false;
    }
    var data = $(this).serialize();
    swal({
        text: "Espere un momento",
        icon: imageURL,
        button: false,
    });

    var formData = new FormData();
    formData.append('name', $('#formWork input[name=name]').val());
    formData.append('lastname', $('#formWork input[name=lastname]').val());
    formData.append('mail', $('#formWork input[name=mail]').val());
    formData.append('phone', $('#formWork input[name=phone]').val());
    formData.append('city', $('#formWork input[name=city]').val());
    formData.append('vacancy', $('#formWork select[name=vacancy]').val());
    formData.append('description', $('#formWork textarea[name=description]').val());
    formData.append('file', $('#formWork input[name=cv_file]')[0].files[0]);
    formData.append('token', $('#formWork input[name=token]').val());;

    $.ajax({
        url: https + "/savework",
        method: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (data) {
            if ($.trim(data) == "1") {
                $("#formWork")[0].reset();
                swal.close();
                swal({
                    text: "Gracias por solicitar, trabajar con nosotros",
                    icon: imageURL,
                    button: "OK!",
                });
            }else {
                console.log(data);
                swal({
                    text: "Error, hubo problemas",
                    icon: imageURL,
                    button: "OK!",
                });
            }
        }
    });
});

function validationForm(elementsForm,contLogin)
{
    for(var i=0;i<elementsForm.length;i++){
        $('#'+elementsForm[i]).removeClass('error');
        if ( $.trim($("#"+elementsForm[i]).val()) == "" ) {
            contLogin = 0;
            $('#'+elementsForm[i]).addClass('error');
        }
    }
    return contLogin;
}
